import React from 'react'
import { Card, Col, FormControl, Row } from 'react-bootstrap'
import BtnBack from '../../../../btn-back'
import { getWelfarePVDAPI } from '../../../../../services/welfare-pvd'
import { useState } from 'react'
import { useEffect } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import Error_false from '../../../../error/error-false'
import { useForm } from 'react-hook-form'
import ButtonSummit from '../../employee-info/_btn-summit'
import { BsExclamationCircle, BsPlusLg } from 'react-icons/bs'
import {
  createProvidentFundAPI,
  editProvidentFundAPI
} from '../../../../../services/provident-fund'
import UseTypeOfFund from '../../../pvd/pvd-select-type'
import SwalCustom from '../../../../../alert/swal-custom'
import { TXTSUCCESS } from '../../../../../Constants'
import AutocompleteCustom from '../../../../custom/autocomplete'
import CustomDatePicker from '../../../../custom/CustomDatePicker'
import LabelCustomSmall from '../../../../label-custom-small'
import fnUpdateArr from '../../../../../helper/fnUpdateArr'
import { fnDateEn } from '../../../../../helper/fnDateEn'
import UseCheckStatusAdmin from '../../../../../hooks/use-check-status-admin'
import { FaAnglesRight } from 'react-icons/fa6'
import { useSelector } from 'react-redux'

export default function EmpWelfarePVD() {
  const statusAdmin = UseCheckStatusAdmin()

  // let [searchParams, setSearchParams] = useSearchParams()
  // const orgId = searchParams.get('orgId')
  // const code = searchParams.get('code')
  // const name = searchParams.get('name')

  // const username = searchParams.get('username')

  const { profile } = useSelector((state) => state.profileReducer)
  const orgId = profile?.orgId
  const code = profile?.code
  const username = profile?.username
  const name = `${profile?.name_en} ${profile?.surname_en}`

  const param = { orgId, code }
  const [dataPVD, setDataPVD] = useState([])
  const [isRead, setIsRead] = useState(true)

  const [isLoading, setIsLoading] = useState(true)

  const { handleSubmit } = useForm()

  const TypePlan = UseTypeOfFund()

  useEffect(() => {
    if (orgId && code) {
      getWelfarePVD()
    }
  }, [orgId, code])

  const getWelfarePVD = async () => {
    setIsLoading(true)
    const resp = await getWelfarePVDAPI(param)
    setIsLoading(false)
    if (!resp) return
    if (resp.status) {
      setDataPVD(
        resp.result.map((d) => ({
          ...d,
          ...(d.plan_id && {
            planType: { label: d.plan_name, value: d.plan_id }
          })
        }))
      )
    } else {
      Error_false(resp)
    }
  }

  const fnChangeData = (id, todo) => {
    const newData = fnUpdateArr(dataPVD, id, todo)
    setDataPVD(newData)
  }

  const onSubmitUpdate = async () => {
    setIsSubmitted(true)
    const _d = dataPVD.find((item) => item.status_id === 1)

    const body = {
      percent: _d.percent ?? '',
      startDate: _d.start_date,
      endDate: _d.end_date ?? '',
      planId: _d.planType?.value
    }
    const resp = await editProvidentFundAPI(
      { ...param, username, pvdId: _d.id },
      body
    )
    setIsSubmitted(false)

    if (!resp) return
    if (resp.status) {
      SwalCustom({
        title: `Success!`,
        text: TXTSUCCESS,
        timer: 1500,
        showConfirmButton: false
      }).then(() => {
        getWelfarePVD()
        setIsRead(true)
      })
    } else {
      Error_false(resp)
    }
  }

  const [newPDV, setNewPDV] = useState({
    percent: '',
    start_date: null,
    end_date: null,
    planType: null
  })

  const [isSubmit, setIsSubmit] = useState(false)
  const [isSubmitted, setIsSubmitted] = useState(false)
  const onSubmitCreate = async (body) => {
    setIsSubmitted(true)
    const datas = await createProvidentFundAPI(body)
    setIsSubmitted(false)
    if (!datas) return
    if (datas.status === true) {
      SwalCustom({
        title: `Success!`,
        text: TXTSUCCESS,
        timer: 1500,
        showConfirmButton: false
      }).then(() => {
        getWelfarePVD()
        setIsRead(true)
        setIsSubmit(false)
        setNewPDV({
          percent: '',
          start_date: null,
          end_date: null,
          planType: null
        })
      })
    } else {
      Error_false(datas)
    }
  }

  const FromCreatePVD =
    statusAdmin?.status_id === 1 ? (
      <Row className="g-4 mb-5">
        <Col xl={12}>
          <div className="d-flex justify-content-between">
            <label className="fw-bold my-auto">เพิ่มสมาชิกกองทุน</label>
            <ButtonSummit
              textPimary={
                <>
                  <BsPlusLg className="me-2" /> Add Member
                </>
              }
              fnCancle={() => {
                setNewPDV({
                  percent: '',
                  start_date: null,
                  end_date: null,
                  planType: null
                })
                setIsSubmit(false)
              }}
              isRead={isRead}
              setIsRead={setIsRead}
              isSave={isSubmitted}
              handleSubmit={() => {
                const body = {
                  orgId,
                  username,
                  code,
                  percent: newPDV.percent,
                  startDate: newPDV.start_date,
                  planId: newPDV.planType?.value
                }
                setIsSubmit(true)
                if (newPDV.percent && newPDV.start_date) {
                  onSubmitCreate(body)
                }
              }}
            />
          </div>
        </Col>

        {!isRead ? (
          <>
            <Col xl={12}>
              <LabelCustomSmall>สมาชิก</LabelCustomSmall>
              <div>{name}</div>
            </Col>
            <Col xl={4}>
              <LabelCustomSmall>วันที่เข้ากองทุน</LabelCustomSmall>
              <CustomDatePicker
                showYearDropdown
                showMonthDropdown
                onChange={(e) => {
                  setNewPDV((prev) => ({
                    ...prev,
                    start_date: e ? fnDateEn(e).format('YYYY-MM-DD') : null
                  }))
                }}
                value={newPDV.start_date}
              />
              {!newPDV.start_date && isSubmit && (
                <label className="small text-danger fw-light">
                  <BsExclamationCircle /> Required field
                </label>
              )}
            </Col>
            <Col xl={4}>
              <LabelCustomSmall>หักจากเงินเดือน (%)</LabelCustomSmall>

              <FormControl
                required
                value={newPDV.percent}
                onChange={(e) => {
                  setNewPDV((prev) => ({
                    ...prev,
                    percent: e.target.value
                  }))
                }}
                type="number"
                min={1}
                maxLength={100}
              />
              {!newPDV.percent && isSubmit && (
                <label className="small text-danger fw-light">
                  <BsExclamationCircle /> Required field
                </label>
              )}
            </Col>

            <Col xl={4}>
              <LabelCustomSmall>ประเภทกองทุน</LabelCustomSmall>

              <AutocompleteCustom
                isClearable={true}
                options={TypePlan}
                value={newPDV.planType}
                onChange={(e) => {
                  setNewPDV((prev) => ({
                    ...prev,
                    planType: e
                  }))
                }}
              />
            </Col>
          </>
        ) : (
          <>
            <p className="text-center">
              - ยังไม่เป็นสมาชิกกองทุนสำรองเลี้ยงชีพ (PVD) -
            </p>
          </>
        )}
      </Row>
    ) : (
      <p className="text-center">
        - ไม่อยู่ในสมาชิกกองทุนสำรองเลี้ยงชีพ (PVD) -
      </p>
    )

  return (
    <Col xl={12}>
      <Card border="0" className="h-full">
        <Card.Body className="">
          <h5>
            <Link
              to={-1}
              className={`my-auto text-reset text-decoration-none  pointer-event`}
            >
              <span className="text-primary">
                การลงทุน <FaAnglesRight />
              </span>
              <label className="small fw-light ms-2">
                กองทุนสำรองเลี้ยงชีพ (PVD)
              </label>
            </Link>
          </h5>
          <div className="mb-4" />

          {isLoading ? (
            <Row className="g-4 mb-5">
              <Col xl={12}>
                <p className="placeholder col-12"></p>
              </Col>
              <Col xl={4}>
                <p className="placeholder h3 col-12"></p>
              </Col>
              <Col xl={4}>
                <p className="placeholder h3 col-12"></p>
              </Col>
              <Col xl={4}>
                <p className="placeholder h3 col-12"></p>
              </Col>
              <Col xl={4}>
                <p className="placeholder h3 col-12"></p>
              </Col>
            </Row>
          ) : (
            <>
              {dataPVD.length > 0 ? (
                dataPVD.map((d, i) =>
                  d.status_id === 1 ? (
                    <Row className="g-4 mb-5">
                      <Col xl={12}>
                        <div className="d-flex justify-content-between">
                          <label className="fw-bold my-auto">
                            {d.type_name}
                          </label>
                          {statusAdmin?.status_id === 1 && (
                            <ButtonSummit
                              isRead={isRead}
                              setIsRead={setIsRead}
                              isSave={isSubmitted}
                              handleSubmit={handleSubmit(onSubmitUpdate)}
                            />
                          )}
                        </div>
                      </Col>
                      <Col xl={4}>
                        <LabelCustomSmall>
                          วันที่เข้ากองทุนเข้ารอบที่ {i + 1}
                        </LabelCustomSmall>
                        <CustomDatePicker
                          showYearDropdown
                          showMonthDropdown
                          disabled={isRead}
                          onChange={(e) => {
                            fnChangeData(d.id, {
                              start_date: e
                                ? fnDateEn(e).format('YYYY-MM-DD')
                                : null
                            })
                          }}
                          value={d.start_date}
                        />
                      </Col>
                      <Col xl={4}>
                        <LabelCustomSmall>หักจากเงินเดือน (%)</LabelCustomSmall>

                        <FormControl
                          disabled={isRead}
                          value={d.percent}
                          onChange={(e) => {
                            fnChangeData(d.id, {
                              percent: e.target.value
                            })
                          }}
                          type="number"
                          min={0}
                          maxLength={100}
                        />
                      </Col>
                      <Col xl={4}>
                        <LabelCustomSmall>
                          วันที่ลาออกจากกองทุน
                        </LabelCustomSmall>
                        <CustomDatePicker
                          showYearDropdown
                          showMonthDropdown
                          disabled={isRead}
                          isClearable={true}
                          onChange={(e) => {
                            fnChangeData(d.id, {
                              end_date: e
                                ? fnDateEn(e).format('YYYY-MM-DD')
                                : null
                            })
                          }}
                          value={d.end_date}
                        />
                      </Col>
                      <Col xl={4}>
                        <LabelCustomSmall>ประเภทกองทุน</LabelCustomSmall>

                        <AutocompleteCustom
                          disabled={isRead}
                          isClearable={true}
                          options={TypePlan}
                          value={d.planType}
                          onChange={(e) => {
                            fnChangeData(d.id, { planType: e })
                          }}
                        />
                      </Col>
                    </Row>
                  ) : (
                    <Row className="g-4 mb-5">
                      <Col xl={12}>
                        <label className="fw-bold my-auto">{d.type_name}</label>
                      </Col>
                      <Col xl={4}>
                        <LabelCustomSmall>
                          วันที่เข้ากองทุนเข้ารอบที่ {i + 1}
                        </LabelCustomSmall>
                        <div>
                          {d.start_date
                            ? fnDateEn(d.start_date).format('DD/MM/YYYY')
                            : '-'}
                        </div>
                      </Col>
                      <Col xl={4}>
                        <LabelCustomSmall>หักจากเงินเดือน (%)</LabelCustomSmall>
                        <div>{d.percent}%</div>
                      </Col>
                      <Col xl={4}>
                        <LabelCustomSmall>
                          วันที่ลาออกจากกองทุน
                        </LabelCustomSmall>
                        <div>
                          {d.end_date
                            ? fnDateEn(d.end_date).format('DD/MM/YYYY')
                            : '-'}
                        </div>
                      </Col>
                      <Col xl={4}>
                        <LabelCustomSmall>ประเภทกองทุน</LabelCustomSmall>
                        <div>{d.plan_name ?? '-'}</div>
                      </Col>
                    </Row>
                  )
                )
              ) : (
                <>{FromCreatePVD}</>
              )}

              {dataPVD.length === 1 &&
                dataPVD.filter((item) => item.status_id === 2).length > 0 && (
                  <>{FromCreatePVD}</>
                )}

              {statusAdmin?.status_id === 2 && (
                <div className="text-center">
                  <label className="text-muted">
                    <b>Organization Right:</b> Read Only
                  </label>
                </div>
              )}
            </>
          )}
        </Card.Body>
      </Card>
    </Col>
  )
}
